import { createAction } from 'redux-actions'

export const upgradeRequest = createAction('UPGRADE_REQUEST')
export const upgradeResponse = createAction('UPGRADE_RESPONSE')
export const resetUpgradeState = createAction('UPGRADE_STATE_RESET')
export const setUpgradeState = createAction('UPGRADE_STATE_SET')
